var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_page"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":10,"layout":_vm.layouts,"total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }